import React from "react";
import "./About.css";

const About = () => {
  return <div>about us</div>;
};

export default About;
